/*
 * Copyright (c) 2023 Limpide
 *
 *  Permission is hereby granted, free of charge, to any person obtaining a copy of
 *  this software and associated documentation files (the "Software"), to deal in
 *  the Software without restriction, including without limitation the rights to
 *  use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 *  the Software, and to permit persons to whom the Software is furnished to do so,
 *  subject to the following conditions:
 *
 *  The above copyright notice and this permission notice shall be included in all
 *  copies or substantial portions of the Software.
 *
 *  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 *  FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 *  COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 *  IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 *  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import { SwiperComponent } from '@definitions/swiper'
import Base from '@scripts/components/base'
import { SWIPER_CONFIG } from '@scripts/constants/swiper'
import { SwiperOptions } from 'swiper'

export default class RelatedPosts extends Base {
    element: HTMLElement
    swiper: SwiperComponent

    constructor(element: HTMLElement) {
        super()

        this.element = element
        this.swiper = element.querySelector('swiper-container')
    }

    start() {
        this.ready()

        const pagination = this.element.querySelector('.related-posts-pagination') as HTMLElement
        const configurations: SwiperOptions = {
            ...SWIPER_CONFIG,
            pagination: {
                el: pagination as HTMLElement
            },
            breakpoints: {
                0: { slidesPerView: 1 },
                640: { slidesPerView: 2 },
                768: { slidesPerView: 3 }
            }
        }

        this.swiper && Object.assign(this.swiper, configurations)
        this.swiper && this.swiper.initialize()
    }
}
